/**
 * @generated SignedSource<<fc69fbf29eae12ee72060bd72bafc119>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type ConfluenceEdition = "FREE" | "PREMIUM" | "STANDARD" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type UpgradeEditionButtonFragment$data = {
  readonly __typename: "ConfluenceTenantContext";
  readonly editions: {
    readonly __typename: "Editions";
    readonly confluence: ConfluenceEdition;
  };
  readonly " $fragmentType": "UpgradeEditionButtonFragment";
};
export type UpgradeEditionButtonFragment$key = {
  readonly " $data"?: UpgradeEditionButtonFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"UpgradeEditionButtonFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "__typename"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "UpgradeEditionButtonFragment",
  "selections": [
    {
      "concreteType": "Editions",
      "kind": "LinkedField",
      "name": "editions",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "confluence"
        },
        (v0/*: any*/)
      ]
    },
    (v0/*: any*/)
  ],
  "type": "ConfluenceTenantContext"
};
})();

(node as any).hash = "bee007bb99f1be1656322a1f41effd37";

export default node;
